<template>
    <div class="banner" v-if='bannerImg.length>0'> 
        <el-carousel indicator-position="none" :autoplay='true' height='140px' @change='change'>
            <el-carousel-item v-for="(item,aind) in bannerImg" :key="aind" >
                <div class="pinter" @click="openUrl(item.slideshowLink)">
                    <!-- $imgUrl+ :class="animationList[(aind+1)%3]"-->
                    <el-image ref='imgA' fit='cover' :src="item.slideshowImg?$fileAccessHttpUrl(item.slideshowImg, $imgUrl):$defult"></el-image>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    // props:['bannerImg'],
    watch:{ 
        act:function(newVal){ 
            console.log('act',this.act)
        }
    },
    data() {
        return {
            bannerImg:[
                // {slideshowImg:require('../../assets/img/banner/01.png')},
                // {slideshowImg:require('../../assets/img/banner/02.png')},
                // {slideshowImg:require('../../assets/img/banner/03.png')}
            ],
            animationList:[
                'bounceOutUp','bounceOutRight','bounceInDown'
            ],
            act:0,
            src:require('../../assets/img/图层 5.png'),
            $imgUrl:'',
        };
    },
    mounted() {
        this.getBanner()
    },
    
    methods: {
        change(e){
            this.act=e
        },
        openUrl(url){ 
            if(url){ 
                window.open(url)
            }
        },
        getBanner(){
            if (localStorage.getItem('slideshowTwoList')) {
                this.bannerImg = localStorage.getItem('slideshowTwoList') ? JSON.parse(localStorage.getItem('slideshowTwoList')) : [];
                this.$imgUrl = localStorage.getItem('$imgUrl') ? localStorage.getItem('$imgUrl') : ''
            }
            // this.$get('/web/home/queryHearImg').then(res=>{ 
            //     if(res.success){ 
            //         this.bannerImg=res.message
			// 		console.log(this.bannerImg)
            //     }
            // })
        },
    },
};
</script>

<style lang="scss" scoped>
.banner {
    width: 100%;
    padding: 10px 10px 0px;
    margin: 0 auto;
    &>.el-image {
        display: block;
        width: 100%;
    }
}
</style>
